import React, { useEffect, useState } from "react";
import Header from "../../../../../Componets/Header";
import Status from "../../../../../Componets/Status";
import ActionButton from "../../../../../Componets/Buttons/action";
import Table from "../../../../../Componets/Table";
import toast from "react-hot-toast";
import tables from "../../../../../Data/Tables/Tax/Tax/tables";
import headers from "../../../../../Data/Tables/Tax/Tax/headers";
import Loadercomponent from "../../../../../Componets/Loader";
import { get_all_taxes } from "../../../../../Controllers/Tax/Tax";
import moment from "moment";

const TaxTable = () => {
  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [body, setBody] = useState();

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const paginationdata = (data) => {
    let headerdata = {};

    header?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      taxType: headerdata?.taxType,
      calculationType: headerdata?.calculationType,
      status: headerdata?.status,
    });
  };

  const formdata = (data) => {
    let page = data?.search ? pagination?.currentPage : 1;

    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const actiondata = (data) => {
    let headerdata = {};

    headers?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      taxType: headerdata?.taxType,
      calculationType: headerdata?.calculationType,
      status: headerdata?.status,
      currentPage: pagination?.currentPage,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const params = {
        search: tabledata?.search,
        taxType: tabledata?.taxType,
        calculationType: tabledata?.calculationType,
        status: tabledata?.status,
        page: tabledata?.currentPage,
      };

      const taxes = await get_all_taxes(params);
     
      if (taxes?.status) {
        let data = [];

        taxes?.data?.data?.map((value, index) => {
          data?.push({
            Name: value?.name,
            Code: value?.code,
            Type: value?.taxType?.name,
            "Product Category": value?.category?.name,
            Rate:
              value?.calculationType === "PERCENTAGE"
                ? `${value?.rate}%`
                : value?.rate?.toFixed?.(3),
            "Applicable On": value?.applicableOn,
            Status: (
              <Status
                status={value?.status}
                active="Active"
                inactive="Inactive"
              />
            ),
            Action: (
              <ActionButton
                edit={`/app/settings/tax/edit/${value?._id}`}
                id={value?._id}
                api="delete-tax"
                actiondata={actiondata}
                headers={header}
              />
            ),
          });
        });

        setPagination({
          currentPage: taxes?.data?.currentPage,
          totalCount: taxes?.data?.totalCount,
          totalPages: taxes?.data?.totalPages,
        });

        setBody(data);
        setLoader(false);
      } else {
        toast?.error(taxes?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  const headerReset = () => {
    let componentData = [];
    headers?.components?.map((value, index) => {
      componentData?.push({
        ...value,
        value: null,
      });
    });

    setHeader({ ...headers, components: componentData });
  };

  useEffect(() => {
    fetchData();
    headerReset();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Table
          head={tables}
          body={body}
          pagination={pagination}
          paginationdata={paginationdata}
        />
      </Loadercomponent>
    </Header>
  );
};

export default TaxTable;
